import { Box, Typography } from '@mui/material';
import StepSection from './StepSection';

export default function StepBlock({ imageTitleSrc, stepsData, finalMessage }) {
    return (
        <>
            {/* Título */}
            <Box display="flex" justifyContent="center" my={4}>
                <Box
                    component="img"
                    src={imageTitleSrc}
                    alt="Título da seção"
                    sx={{
                        height: 'auto',
                    }}
                />
            </Box>

            {/* Passos */}
            {stepsData.map((step, idx) => (
                <StepSection key={idx} stepNumber={idx + 1} {...step} />
            ))}

            {/* Texto final*/}
            {finalMessage && (
                <Box display="flex" justifyContent="center" alignItems="flex-end" gap={8} my={4} marginBottom={18}>
                    <Box
                        component="img"
                        src="https://static.meucupom.com/media/2026%20-%20Updates/novo-site/seta_presente.png"
                        alt="Caixa de presente"
                        sx={{ maxWidth: '100%', height: 'auto' }}
                    />
                    <Box sx={{ maxWidth: '458px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Aproveite!
                        </Typography>
                        <Typography variant="h6">
                            {finalMessage}
                        </Typography>
                    </Box>
                </Box>
            )}
        </>
    );
}
